import { Box, Heading, Text } from "@primer/react";
import { Icon } from "@primer/octicons-react";

interface IEmptyStateProps {
    icon?: Icon;
    title: string;
    description?: string;
    action?: React.ReactNode;
    /** "card" = card có shadow + bg, "flat" = inline trong page (default flat). */
    variant?: "card" | "flat";
}

/**
 * Trạng thái rỗng — dùng khi list không có data, period chưa mở, không matching search...
 * Card variant cho landing/empty pages, flat cho table empty rows.
 */
const EmptyState = ({ icon: IconComp, title, description, action, variant = "flat" }: IEmptyStateProps) => {
    const cardSx = variant === "card"
        ? {
              bg: "canvas.default",
              p: 5,
              borderRadius: 3,
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              border: "1px solid",
              borderColor: "border.muted",
              maxWidth: 480,
          }
        : {
              py: 5,
          };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                gap: 2,
                color: "fg.muted",
                ...cardSx,
            }}
        >
            {IconComp && (
                <Box sx={{ color: "fg.muted", mb: 1 }}>
                    <IconComp size={32} />
                </Box>
            )}
            <Heading as="h2" sx={{ fontSize: 4, color: "fg.default", mb: 1 }}>
                {title}
            </Heading>
            {description && (
                <Text sx={{ fontSize: 1, color: "fg.muted", maxWidth: 360 }}>
                    {description}
                </Text>
            )}
            {action && <Box sx={{ mt: 3 }}>{action}</Box>}
        </Box>
    );
};

export default EmptyState;
